import React from "react";

import { SEARCH_TYPE_NAME, SEARCH_TYPE_ALL } from "../../constants.js";

/**
 * Generic Search Fieldset
 *
 * @param {Object} props
 * @param {number} props.searchType current enumerated search type
 * @param {function} props.setSearchType function that sets new search type
 * @param {string} props.searchValue current search string
 * @param {function} props.setSearchValue function that sets new search string on input change
 * @returns {React.JSX.Element} Generic Search Fieldset
 */
export default function HeaderSearch({ searchType, setSearchType, searchValue, setSearchValue }) {
  const handleSearchType = (e) => setSearchType(Number(e.target.value));
  const handleSearchInput = (e) => setSearchValue(e.target.value);
  const handleClearSearch = () => setSearchValue("");

  return (
    <div id="search">
      <div className="col-sm-5">
        <form role="search">
          <fieldset>
            <legend>Search:</legend>
            <div
              className="row form-group text-left"
              id="searchoptions"
              role="radiogroup"
              aria-label="search options"
              aria-controls="contractholderlist"
            >
              <label className="radio-inline" htmlFor="choption">
                <input
                  type="radio"
                  id="choption"
                  role="radio"
                  name="filterValue"
                  value={SEARCH_TYPE_NAME}
                  onChange={handleSearchType}
                  checked={searchType === SEARCH_TYPE_NAME}
                />
                Contract Holder Name
              </label>
              <label className="radio-inline" htmlFor="allfieldsoption">
                <input
                  type="radio"
                  id="allfieldsoption"
                  role="radio"
                  name="filterValue"
                  value={SEARCH_TYPE_ALL}
                  onChange={handleSearchType}
                  checked={searchType === SEARCH_TYPE_ALL}
                />
                All Fields
              </label>
            </div>
            <div className="row text-right search">
              <span className="glyphicon glyphicon-search" aria-hidden="true">
                &nbsp;
              </span>
              <input
                id="searchBox"
                type="text"
                value={searchValue}
                onChange={handleSearchInput}
                title="Search: Enter text to search for a contract holder in the table below"
                name="searchValue"
                placeholder="Contract Holder"
              />
              &nbsp;
              <a className="text-right clickable" onClick={handleClearSearch}>
                clear search
              </a>
            </div>
          </fieldset>
        </form>
      </div>
    </div>
  );
}
